import { parseCookie } from 'cookie';

import { type CookieName, type ICookieService } from './cookie.types';

export class CookieService implements ICookieService {
  #parse() {
    return parseCookie(document.cookie);
  }

  constructor() {}

  get(name: CookieName): string | undefined {
    return this.#parse()[name];
  }
}
